import { css } from '@emotion/react';
import { breakpointMedium } from '@/constants/breakpoints';

const common = css`
overflow-wrap: anywhere;
word-break: keep-all;
`;

export const headline03 = css`
${common}

font-size: 32px;
font-weight: 700;
letter-spacing: -1px;
line-height: 140%; 

@media (max-width: ${breakpointMedium}) {
  font-size: 24px;
}
`;

export const headline04 = css`
${common}

font-size: 26px;
font-weight: 700;
letter-spacing: -1px;
line-height: 140%;

@media (max-width: ${breakpointMedium}) {
  font-size: 22px;
}
`;

export const title02 = css`
${common}

font-size: 18px;
font-weight: 700;
letter-spacing: -0.5px;
line-height: 150%;

@media (max-width: ${breakpointMedium}) {
  font-size: 16px;
}
`;

export const title03 = css`
${common}

font-size: 16px;
font-weight: 700;
letter-spacing: -0.5px;
line-height: 150%;

@media (max-width: ${breakpointMedium}) {
  font-size: 15px;
  font-weight: 700;
}
`;

export const body02 = css`
${common}

font-size: 18px;
font-weight: 400;
letter-spacing: -0.5px;
line-height: 170%;

@media (max-width: ${breakpointMedium}) {
  font-size: 16px;
}
`;

export const body02Medium = css`
${common}

font-size: 18px;
font-weight: 500;
letter-spacing: -0.5px;
line-height: 170%;

@media (max-width: ${breakpointMedium}) {
  font-size: 16px;
}
`;

export const body03 = css`
${common}

font-size: 16px;
font-weight: 400;
letter-spacing: -0.5px;
line-height: 170%;

@media (max-width: ${breakpointMedium}) {
  font-size: 15px;
}
`;

export const body03Medium = css`
${common}

font-size: 16px;
font-weight: 500;
letter-spacing: -0.5px;
line-height: 170%;

@media (max-width: ${breakpointMedium}) {
  font-size: 15px;
}
`;

export const body04 = css`
${common}

font-size: 14px;
font-style: normal;
font-weight: 400;
letter-spacing: -0.5px;
line-height: 150%;
`;
